module.exports = {
  title: 'Scrollable Shapes with Skia and Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2025-12-16',
  slug: 'scrollable-shapes',
  tags: ['skia', 'reanimated'],
};
